export const SET_DASHBOARD_OVERVIEW_DATAS = 'Dashboard/OverviewDatas/set';
export const SET_DASHBOARD_MAP_LOCKS = 'Dashboard/MapLocks/set';
export const SET_DASHBOARD_SWITCH_DATAS = 'Dashboard/SwitchDatas/set';
export const SET_DASHBOARD_SETTING_DATAS = 'Dashboard/SettingDatas/set';
export const SET_DASHBOARD_CHART_DATAS = 'Dashboard/ChartDatas/set';
export const SET_DASHBOARD_CHART_DATE_RANGE = 'Dashboard/ChartDateRange/set';
export const SET_DASHBOARD_TASKS = 'Dashboard/Tasks/set';
export const SET_DASHBOARD_MAP_WORKERS = 'Dashboard/MapWorkers/set';
export const SET_DASHBOARD_AUTHORITYS = 'Dashboard/Authoritys/set';
